import { APICore } from '../../helpers/api/apiCore';
import * as URL from '../../helpers/api/apiEndPoint';

const api = new APICore();
// -------------------------------------------------------I N B O U N D-------------------------------------------------------
function inbound(data: any): any {
    let { search, limit, pages, userId } = data?.data;
    return api.get(`${URL.GET_INBOUND}?&search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}&userId=${userId}`);
}

function editInboundDataApi(data: any): any {
    let { id } = data?.data;
    return api.get(`${URL.GET_EDIT_INBOUND_DATA}?id=${encodeURIComponent(id)}`);
}
function createInbound(params: any): any {
    const { data } = params;
    return api.create(URL.POST_INBOUND, data);
}

function updateInbound(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_INBOUND, data);
}
function deleteInbound(params: any): any {
    const { id, userId } = params?.data;
    return api.delete(`${URL.DELETE_INBOUND}?_id=${id}&userId=${userId}`);
}
function uploadInbound(params: any): any {
    const { data } = params;
    return api.create(URL.UPLOAD_INBOUND, data);
}
// ---------------------------------------------------_--_-_--_-_----_-_-_--T A G  N O _--__--_-_-_-_-_-__-_-_-_-_---_-_-_
function tagNo(data: any): any {
    let { sort, id, field } = data?.data;
    return api.get(`${URL.GET_DOC}sortOrder=${sort}&uniqueId=${id}&sortField=${field}`);
}

function tagData(data: any): any {
    let { id } = data?.data;
    return api.get(`${URL.GET_TAG}tagNumber=${id}`);
}
// ---------------------------------------------------_--_-_--_-_----_-_-_--M U L T I P L E U P D A T E _--__--_-_-_-_-_-__-_-_-_-_---_-_-_

function updateAll(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_ALL, data);
}
function updateAllSellingPrice(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_ALL_SELLING_PRICE, data);
}

function updateAllYards(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_YARDS, data);
}
function updateSelected(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_SELECTED, data);
}
function updateSelectedUnit(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_SELECTED_UNIT, data);
}
function updateInventoryTransactions(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_INVENTORY_TRANSACTION, data);
}
function gatDetailsbyTag(params: any): any {
    const { id } = params?.data;
    return api.get(`${URL.GET_BY_TAG}_id=${id}`);
}

function getByDoc(params: any): any {
    const { doc } = params?.data;
    return api.get(`${URL.GET_BY_DOC}documentNumber=${doc}`);
}

function getPrintContent(params: any): any {
    const { uniqId } = params?.data;
    return api.get(`${URL.GET_PRINT_CONTENT}uniqueId=${uniqId}`);
}

function getExcelContent(params: any): any {
    const { uniqId } = params?.data;
    return api.get(`${URL.GET_EXCEL_CONTENT}uniqueId=${uniqId}`);
}
function updateTagnoByStatus(params: any): any {
    const { data } = params;
    return api.update(`${URL.UPDATE_TAG_BU_STATUS}`, data);
}

function updateAllDescription(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_ALL_DESCRIPTION, data);
}
function updateSelectedDescription(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_SELECTED_DESCRIPTION, data);
}

function getInvoiceData(params: any): any {
    const { uniqId } = params?.data;
    return api.get(`${URL.GET_INVOICE_DATA}uniqueId=${uniqId}`);
}

function getReceiverData(params: any): any {
    const { uniqId } = params?.data;
    return api.get(`${URL.GET_RECEIVER_DATA}uniqueId=${uniqId}`);
}


function updateAllUnits(params: any): any {
    const { data } = params;
    return api.update(URL.UPDATE_ALL_UNITS, data);
}
export {
    inbound,
    editInboundDataApi,
    createInbound,
    uploadInbound,
    updateInbound,
    deleteInbound,
    tagNo,
    tagData,
    updateAll,
    updateAllYards,
    updateSelected,
    updateSelectedUnit,
    updateInventoryTransactions,
    gatDetailsbyTag,
    getByDoc,
    getPrintContent,
    getExcelContent,
    updateTagnoByStatus,
    updateAllSellingPrice,
    updateAllDescription,
    updateSelectedDescription,
    getInvoiceData,
    getReceiverData,
    updateAllUnits
};
